
import { httpss } from "../utils/host";
export const createRoute = `${httpss}/apis_v1/submission/create`;
export const updateRoute = `${httpss}/apis_v1/submission/update_status`;
export const getSubmissionById = `${httpss}/apis_v1/submission/user_submissions`;
export const getSubmission = `${httpss}/apis_v1/submission/`;
export const updateSubmissionStatus = `${httpss}/apis_v1/submission/update_status`;
export const getSubmissionByLink = `${httpss}/apis_v1/submission/get_by_link`;
export const exportCSVRoute = `${httpss}/apis_v1/submission/export-csv`;